<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="出勤名称" prop="title">
        <el-input v-model="dataForm.title" placeholder="出勤表名称"></el-input>
      </el-form-item>
      <el-form-item label="班级名称">
        <el-select v-model="dataForm.classId" placeholder="班级名称" @change="changeSchoolHandle()">
          <el-option v-for="tempClass in classList" :value="tempClass.classId" :label="tempClass.className" :key="tempClass.classId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出勤时间" prop="attendanceTime">
        <div class="block">
          <el-date-picker
                  v-model="dataForm.attendanceTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      classList: [],
      dataForm: {
        id: '',
        title: '',
        classId: '',
        className: '',
        attendanceTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
        this.getTeachingClassList()
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/studentEvaluate/attendance/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 获取教师授课班级列表
    getTeachingClassList () {
      this.$http.get('/teacher/teacherClassConfig/viewTeachingClassList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.classList = res.data
      }).catch(() => {
        console.log(this.classList)
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      console.log(this.dataForm)
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/studentEvaluate/attendance/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
